import request from '@/utils/request'
import requestJson from "@/utils/requestJson"

export function orderSellGetList(data) {
  return request({
    url: '/admin/order_sell/getList',
    method: 'get',
    params: data
  })
}

export function orderSellGetOne(data) {
  return request({
    url: '/admin/order_sell/getOne',
    method: 'get',
    params: data
  })
}
export function orderSellDel(data) {
  return request({
    url: '/admin/order_sell/del',
    method: 'get',
    params: data
  })
}


export function orderSellAdd(data) {
  return requestJson({
    url: '/admin/order_sell/add',
    method: 'post',
    data
  })
}

export function orderSellUp(data) {
  return requestJson({
    url: '/admin/order_sell/up',
    method: 'post',
    data
  })
}

export function orderSellSearchCode(data) {
  return request({
    url: '/admin/order_sell/search_code',
    method: 'post',
    data
  })
}


// 下载今日外卖单
export function mailAlert(data) {
  return request({
    url: '/admin/Pospal/getPosOrder',
    method: 'get',
    params: data
  })
}

// 下载外卖单麦芽田运费
export function downloadMytLogisticsFeeData(data) {
  return request({
    url: '/admin/Pospal_logistics_cost/getMytWmList',
    method: 'get',
    params: data
  })
}

// 推送昨日外卖单
export function pushYesterdayOrder(data) {
  return request({
    url: '/admin/Report_push/todayTakeOutInfo',
    method: 'get',
    params: data
  })
}

// 外卖单列表
export function orderTakeoutGetList(data) {
  return request({
    url: '/admin/order_takeout/getList',
    method: 'get',
    params: data
  })
}

// 刷单
export function orderTakeoutSetRefresh(data) {
  return request({
    url: '/admin/order_takeout/setRefresh',
    method: 'get',
    params: data
  })
}
export function orderTakeoutSetUnRefresh(data) {
  return request({
    url: '/admin/order_takeout/setUnRefresh',
    method: 'get',
    params: data
  })
}

// 跳过
export function orderTakeoutSetJump(data) {
  return request({
    url: '/admin/order_takeout/setJump',
    method: 'get',
    params: data
  })
}
export function orderTakeoutSetUnJump(data) {
  return request({
    url: '/admin/order_takeout/setUnJump',
    method: 'get',
    params: data
  })
}


// 撤回
export function orderSellUnDo(data) {
  return request({
    url: '/admin/order_sell/unDo',
    method: 'get',
    params: data
  })
}

export function orderSellUnDoFormSn(data) {
  return request({
    url: '/admin/order_sell/unDoFormSn',
    method: 'get',
    params: data
  })
}

export function orderTakeoutGetOne(data) {
  return request({
    url: '/admin/order_takeout/getOne',
    method: 'get',
    params: data
  })
}

// 批量添加
export function orderSellBatchAdd(data) {
  return requestJson({
    url: '/admin/order_sell/batchAdd',
    method: 'post',
    data
  })
}

export function sleepGetOne2(data) {
  return request({
    url: '/admin/pospal/getOne2',
    method: 'get',
    params: data
  })
}

// 更改运费账号
export function upPayforMoveId(data) {
  return requestJson({
    url: '/admin/order_takeout/upPayforMoveId',
    method: 'post',
    data
  })
}

// 销售统计接口
export function getOrderAllInfo(data) {
  return request({
    url: '/admin/order_sell/getOrderAllInfo',
    method: 'get',
    params: data
  })
}

// 更新列表上的运费
export function setPayForMove(data) {
  return request({
    url: '/admin/order_takeout/setPayForMove',
    method: 'post',
    data
  })
}

// 更新列表上的刷单手续费
export function setPayForSdFee(data) {
  return request({
    url: '/admin/order_takeout/setPayForSdFee',
    method: 'post',
    data
  })
}

// 销售单退款退货
export function orderSellRefundReturn(data) {
  return request({
    url: '/admin/order_sell/refundReturn',
    method: 'get',
    params: data
  })
}

// 销售单一键撤销
export function orderSellBatchCancel(data) {
  return request({
    url: '/admin/order_sell/batchCancel',
    method: 'get',
    params: data
  })
}

// 销售单一键刷单
export function orderSellOneClickReorder(data) {
  return request({
    url: '/admin/order_sell/oneClickReorder',
    method: 'get',
    params: data
  })
}


export function doBatchAdd(data) {
  return requestJson({
    url: '/admin/order_sell/doBatchAdd',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/sale.js